import type { ICharacter, IListResponse } from '@dakedake/types'
import { request } from '@umijs/max'

/** 添加人物 POST /backend/character/add */
export async function characterAdd(body: ICharacter, options?: Record<string, any>) {
  return request<{ data: ICharacter, success: boolean, message: string }>('/backend/character/add', {
    method: 'POST',
    data: body,
    ...options
  })
}

/** 更新人物 POST /backend/character/edit */
export async function characterEdit(body: ICharacter, options?: Record<string, any>) {
  return request<{ data: ICharacter, success: boolean, message: string }>(`/backend/character/${body.id}`, {
    method: 'PUT',
    data: body,
    ...options
  })
}

/** 删除人物 POST /backend/character/delete */
export async function characterDelete(body: { id?: number }, options?: Record<string, any>) {
  return request<{ data: ICharacter, success: boolean, message: string }>(`/backend/character/${body.id}`, {
    method: 'DELETE',
    data: body,
    ...options
  })
}

/** 获取人物列表 GET /backend/character/list */
export async function characterList(
  params: {
    // query
    /** 当前的页码 */
    current?: number
    /** 页面的容量 */
    pageSize?: number
    [key: string]: any
  },
  options?: Record<string, any>
) {
  return request<IListResponse<ICharacter>>('/backend/character/list', {
    method: 'GET',
    params: {
      ...params
    },
    ...options
  })
}

/** 获取人物详情 GET /backend/character/{id} */
export async function characterDetail(id: number, options?: Record<string, any>) {
  return request<{ data: ICharacter, success: boolean, message: string }>(`/backend/character/${id}`, {
    method: 'GET',
    ...options
  })
}

/** 更新封面 POST /backend/character/editCover */
export async function characterEditCover(body: { id?: number, cover?: number | null }, options?: Record<string, any>) {
  return request<{ data: ICharacter, success: boolean, message: string }>('/backend/character/editCover', {
    method: 'POST',
    data: body,
    ...options
  })
}
